// Detect embedded HTML-commented JSON data structures with already-rendered values
// If detected, run through the specified parsers
// If parsed text is created, then return the parsed text and stop

export const getObjectfromHTMLComment = value => {
    const htmlEmbeddedJsonRegex = /\<!--\[JSON\[.*?]]-->/;
    const match = value.match(htmlEmbeddedJsonRegex);
    if(match) {
        let json = match[0];
        json = json.replace('<!--[JSON[','');
        json = json.replace(']]-->','');
        const test = JSON.parse(json);
        return test;
    }
    return null;
};